<top-banner variant="title" [title]="selectedContractor?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">

            <!-- Message for when a user is set up by skylark admin without connecting the site owner to the contractor -->
            <div *ngIf="missingSiteOwnerLink && selectedContractor" class="warning-banner">
              <div class="temporary-information-message">
                <div>
                  <i class="fas fa-info-circle"></i>
                </div>
                <div>
                  <p>
                    There is a data mismatch for this company. Please email Skylark at the <a>controlcentre@skylarkcontrol.com</a> with the following info:
                  </p>
                  <dl class="sideways-dl">
                    <p>Missing contractor to site link</p>
                    <p>Contractor: {{ selectedContractor.id }} - {{ selectedContractor.name }} --- Site Owner: {{ siteOwnerSkylarkUserId }}</p>
                  </dl>
                </div>
              </div>
            </div>

            <h4 class="card-title">Workers</h4>
            <div class="mb-2 animated fadeIn">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-end">
                  <button type="button" (click)="columnOptionsSidebarVisible = true" class="btn btn-round btn-primary btn-sm ml-3">toggle columns</button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p-table
                      [autoLayout]="true"
                      [value]="contractorWorkers"
                      selectionMode="single"
                      (onRowSelect)="onRowSelect($event)"
                      (onSort)="customSort($event)"
                      [sortField]="defaultSortField"
                      [sortOrder]="defaultSortOrder"
                      [lazy]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="table-cell-centered">Activated</th>
                        <th *ngIf="this.routeRole === 'power-station-owner' || this.routeRole === 'power-station-manager'" class="table-cell-centered">Added to Site</th>
                        <th [pSortableColumn]="'user.lastName'">Name
                          <p-sortIcon [field]="'user.lastName'"></p-sortIcon>
                        </th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Email')">Email</th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Username')">Username</th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Phone')">Phone</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-user>
                      <tr [pSelectableRow]="user">
                        <td class="table-cell-centered">
                          <i *ngIf="user.activated" class="fas fa-check-circle success"></i>
                          <i *ngIf="!user.activated" class="fas fa-times-circle danger"></i>
                        </td>
                        <td *ngIf="this.routeRole === 'power-station-owner' || this.routeRole === 'power-station-manager'" class="table-cell-centered">
                          <ng-container *ngIf="user.isApprovedOnSite !== undefined">
                            <span *ngIf="user.isApprovedOnSite">&nbsp;<i class="fas fa-check-circle success"></i></span>
                            <span *ngIf="! user.isApprovedOnSite">&nbsp;<i class="fas fa-times-circle danger"></i></span>
                          </ng-container>
                        </td>
                        <td>
                          <a
                            [routerLink]="['/', routeRole, 'workers', user.id, 'manage-competencies']"
                            [queryParams]="{ backLink: '/' + routeRole + '/contractors/' + selectedContractorId + '/workers' }">
                            {{ user.firstName }} {{ user.lastName }}
                          </a>
                        </td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Email')">{{ user.email }}</td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Username')">{{ user.login }}</td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Phone')">{{ user.workerUser.phoneNumber }}</td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="5">No users found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <p-paginator
                #paginator
                [rows]="pagination.size"
                [totalRecords]="pagination.totalRecords"
                [rowsPerPageOptions]="pageSizes"
                (onPageChange)="paginate($event)">
              </p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- column options sidebar -->
<p-sidebar [(visible)]="columnOptionsSidebarVisible" position="right" [baseZIndex]="1000000">
  <h6 class="text-primary my-4">Column Options</h6>
  <label>Show:</label>
  <ng-container *ngFor="let col of ( togglableColumns )">
    <div class="form-group">
      <p-checkbox name="togglableColumns" [value]="col.displayName" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="col.displayName"></p-checkbox>
    </div>
  </ng-container>
  <button (click)="resetColumnOptions()" class="mt-4 btn btn-round btn-default btn-simple btn-block">reset to default</button>
</p-sidebar>
